module.exports = __webpack_public_path__ + "img/tyre.e5d6fd87.png";